<template>
    <div class="loading">
        <img src="../../public/img/loading.gif" style="width: 380px;height: 200px;" alt="">
    </div>
</template>

<script>
    export default {
        name: 'Loading' // 定义的组件名称 使用时写法：loading
    }
</script>

<style scoped>
    .loading {
        width: 100%;
        height: 100%;
        text-align: center;
    }
</style>